import React, { useMemo } from 'react';
import { Row, Col, Text, Button, FlexboxGrid, Stack } from 'rsuite';
import { isNullUndefinedOrEmptyString, titleize } from '../../../common/utils';
import usePlaceNavigate from '../../../hooks/usePlaceNavigate';
import { C_PERMIT_STATUS_CURRENT } from '../../../common/consts';
import { getAddressWithUnitNumber } from '../../../common/utils';
import dayjs from 'dayjs';

const UsersLicenseRow = ({ license }) => {
  const placeNavigate = usePlaceNavigate();

  const fullAddress = useMemo(() => {
    return getAddressWithUnitNumber(
      license.property_address,
      license.unit_number
    );
  }, [license]);

  const { expirationDateOrStatus, isExpirationDateOrStatusItalic } =
    useMemo(() => {
      if (license.status !== C_PERMIT_STATUS_CURRENT) {
        return {
          expirationDateOrStatus: titleize(license.status),
          isExpirationDateOrStatusItalic: true,
        };
      }

      const expDate = license.expiration_date;
      if (isNullUndefinedOrEmptyString(expDate)) {
        return {
          expirationDateOrStatus: 'Expiration: -',
          isExpirationDateOrStatusItalic: false,
        };
      }

      const isValidDate = dayjs(expDate).isValid();
      return {
        expirationDateOrStatus: isValidDate
          ? `Expiration: ${dayjs(expDate).format('YYYY-MM-DD')}`
          : titleize(expDate),
        isExpirationDateOrStatusItalic: !isValidDate,
      };
    }, [license]);

  return (
    <FlexboxGrid
      className="pb-4"
      as={Row}
      key={`license_${license.license_else_application_number}`}
      gutter={10}
      align="middle"
    >
      <FlexboxGrid.Item
        role="cell"
        as={Col}
        xs={24}
        sm={19}
      >
        <div role="grid">
          <Row className="ph-4 pv-4">
            <Col
              xs={24}
              className="mb-8 mt-4"
            >
              <Stack direction="row">
                {license.status !== 'submitted' && (
                  <Text className="license-indicator-dot">•</Text>
                )}

                <Text className="text-bold">{titleize(fullAddress)}</Text>
              </Stack>
            </Col>
            <Col
              xs={24}
              lg={12}
              className="pb-lg-lower-8"
            >
              <Text>{license.license_else_application_number}</Text>
            </Col>
            <Col
              lg={12}
              className="pb-lg-lower-8"
            >
              <Text as={isExpirationDateOrStatusItalic ? 'i' : 'span'}>
                {expirationDateOrStatus}
              </Text>
            </Col>
          </Row>
        </div>
      </FlexboxGrid.Item>
      <FlexboxGrid.Item
        className="pr-12 pt-4"
        as={Col}
        xs={24}
        lg={5}
      >
        <Button
          className="btn-tertiary"
          style={{ width: '100%' }}
          onClick={() => {
            placeNavigate(`/single-permit/${license.application_number}`);
          }}
          data-cy="single-permit-button"
        >
          View
        </Button>
      </FlexboxGrid.Item>
    </FlexboxGrid>
  );
};

export default UsersLicenseRow;
